import { JsonClassType, JsonProperty, ObjectMapper } from "@outfoxx/jackson-js";
import { JsonParserContext } from "@outfoxx/jackson-js/dist/@types";
import { Geometry } from "modules/construction-work/src/Entity/Work/Geometry";
import { Properties } from "modules/construction-work/src/Entity/Work/Properties";

export class ConstructionWorkMap {
    @JsonProperty()
    @JsonClassType({ type: () => [Geometry] })
    geometry: Geometry;
    @JsonProperty()
    @JsonClassType({ type: () => [Properties] })
    properties: Properties;
    @JsonProperty()
    type: string;

    public static createByObj(object): ConstructionWorkMap {
        if (!object) {
            throw new Error();
        }

        const objectMapper = new ObjectMapper();
        const context = { mainCreator: () => [ConstructionWorkMap] } as JsonParserContext;

        return objectMapper.parse<ConstructionWorkMap>(JSON.stringify(object), context);
    }
}